import React, { Component } from 'react';
import {
  Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import SectionAilment from './SectionAilment';
import Habits from './Habits';
import { Field, reduxForm } from "redux-form";

class DefaultTabsBorderedTopBackground extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      activeTab: '1',
      //load: false,
      sectionAilment: {}
    };
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  componentDidMount() {
    
  }

  render() {
    
    const { activeTab } = this.state;

    return (
      <Col>
        <Card>
        <CardBody>
          <div className="tabs tabs--bordered-top">
            <div className="tabs__wrap">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => {
                      this.toggle('1');
                    }}
                  >
                    Patologicos
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => {
                      this.toggle('2');
                    }}
                  >
                    Quirurgicos
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '3' })}
                    onClick={() => {
                      this.toggle('3');
                    }}
                  >
                    Farmacologicos
                  </NavLink>
                </NavItem>  
                {this.props.gender === "Femenino" ?              
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '4' })}
                    onClick={() => {
                      this.toggle('4');
                    }}
                  >
                    Ginecobstétricos
                  </NavLink>
                </NavItem>
                : null }
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '5' })}
                    onClick={() => {
                      this.toggle('5');
                    }}
                  >
                    Inmunizaciones
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '6' })}
                    onClick={() => {
                      this.toggle('6');
                    }}
                  >
                    Hábitos
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '7' })}
                    onClick={() => {
                      this.toggle('7');
                    }}
                  >
                    Otros
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '8' })}
                    onClick={() => {
                      this.toggle('8');
                    }}
                  >
                    Familiares
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                <SectionAilment 
                    sectionIndex={0}
                    section={this.props.sections[0]} 
                    ailments={this.props.ailments[0]}
                    sectionAilment={this.props.sectionAilment.ailments[0]}
                    commentary={this.props.sectionAilment.commentary}
                    handlerAilment={this.props.handlerAilment}
                    handlerComments={this.props.handlerComments}
                    handlerCommentary={this.props.handlerCommentary}
                    handlerObservation={this.props.handlerObservation}
                  />
                </TabPane>
                <TabPane tabId="2">
                  {/*<SectionAilment section="quirurgico"  ailments={["quirurgico"]}/>*/}
                  <SectionAilment
                    sectionIndex={1}
                    section={this.props.sections[1]} 
                    ailments={this.props.ailments[1]}
                    sectionAilment={this.props.sectionAilment.ailments[1]}
                    commentary={this.props.sectionAilment.commentary}
                    handlerAilment={this.props.handlerAilment}
                    handlerComments={this.props.handlerComments}
                    handlerCommentary={this.props.handlerCommentary}  
                  />
                </TabPane>
                <TabPane tabId="3">
                  {/* <SectionAilment section="Farmacologico"  ailments={["Farmacologico"]} />*/}
                  <SectionAilment 
                    sectionIndex={2}
                    section={this.props.sections[2]} 
                    ailments={this.props.ailments[2]}
                    sectionAilment={this.props.sectionAilment.ailments[2]}
                    commentary={this.props.sectionAilment.commentary}
                    handlerAilment={this.props.handlerAilment}
                    handlerComments={this.props.handlerComments}
                    handlerCommentary={this.props.handlerCommentary} 
                    searchMedicaments={this.props.searchMedicaments} 
                    handlerAlimentTable={this.props.handlerAlimentTable} 
                  />
                </TabPane>
                <TabPane tabId="4">
                 {/* <SectionAilment section="Ginecoobstétricos"  ailments={["Ginecoobstétricos"]} />*/}
                 <SectionAilment 
                    sectionIndex={3}
                    section={this.props.sections[3]} 
                    ailments={this.props.ailments[3]}
                    sectionAilment={this.props.sectionAilment.ailments[3]}
                    commentary={this.props.sectionAilment.commentary}
                    handlerAilment={this.props.handlerAilment}
                    handlerComments={this.props.handlerComments}
                    handlerCommentary={this.props.handlerCommentary}  
                  />
                </TabPane>
                <TabPane tabId="5">
                  {/*<SectionAilment section="Inmunización"  ailments={["Inmunizaciones"]} />*/}
                  <SectionAilment 
                    sectionIndex={4}
                    section={this.props.sections[4]} 
                    ailments={this.props.ailments[4]}
                    sectionAilment={this.props.sectionAilment.ailments[4]}
                    commentary={this.props.sectionAilment.commentary}
                    handlerAilment={this.props.handlerAilment}
                    handlerComments={this.props.handlerComments}
                    handlerCommentary={this.props.handlerCommentary}  
                    handlerAlimentTable={this.props.handlerAlimentTable} 
                  />
                </TabPane>
                <TabPane tabId="6">
                  <Habits 
                    habits={this.props.habits}
                    handlerHabits={this.props.handlerHabits}
                  />
                </TabPane>
                <TabPane tabId="7">
                  {/*<SectionAilment section="Otros"  ailments={["Alergías", "Hospitalario", "Traumatico", "Enfermedades de transmisión sexual", "Psiquiatricos"]} />*/}
                  <SectionAilment 
                    sectionIndex={5}
                    section={this.props.sections[5]} 
                    ailments={this.props.ailments[5]}
                    sectionAilment={this.props.sectionAilment.ailments[5]}
                    commentary={this.props.sectionAilment.commentary}
                    handlerAilment={this.props.handlerAilment}
                    handlerComments={this.props.handlerComments}
                    handlerCommentary={this.props.handlerCommentary}  
                  />
                </TabPane>
                <TabPane tabId="8">
                  {/*<SectionAilment section="Familiares"  ailments={["Enfermedad Coronaria", "diabetes", "Cancer", "muerte subita (H < 55/M < 60)", "hipertensión"]} />*/}
                  <SectionAilment 
                    sectionIndex={6}
                    section={this.props.sections[6]} 
                    ailments={this.props.ailments[6]}
                    sectionAilment={this.props.sectionAilment.ailments[6]}
                    commentary={this.props.sectionAilment.commentary}
                    handlerAilment={this.props.handlerAilment}
                    handlerComments={this.props.handlerComments}
                    handlerCommentary={this.props.handlerCommentary}
                  />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </CardBody>
      </Card>
      </Col>
    );
  }
}
export default reduxForm({
  form: "patient-background",
})(withTranslation("common")(DefaultTabsBorderedTopBackground));
